import React, { useState, useEffect } from "react";
import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { Layout, Space, PageHeader, Row, Col, Button ,Empty} from "antd";
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Card, Typography } from "antd";
import PosService from "../../../services/PosService";
import { useSelector } from 'react-redux'
import { useHistory, useRouteMatch } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "../PosServerLogin/style.scss"
import { useLocation } from "react-router-dom";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const { Content } = Layout;

const { Text } = Typography;

const PosTable = (props) => {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);

  const adminRestaurant = useSelector((state) => state.admin)
  const history = useHistory();
  const { search } = useLocation();
  const screens = useBreakpoint();

  useEffect(()=>{
     (async()=>{
      
  const id = new URLSearchParams(search).get("id");
  localStorage.setItem("serverId", id);
     const tabledataRestaurent = await PosService.getRestaurentTables(adminRestaurant,id);

       setData(tabledataRestaurent)
       setLoading(false)
     })()
  },[adminRestaurant])

  const backtoLogin =()=>{
    history.push(`/pos/server-login/`)
  }
  return (
    <Layout style={{ padding: "0 18px 8px" }}>
      <Layout>
        <Content
          className=""
          style={{
            padding: 10,
            margin: "8px 0px",
            minHeight: 280,
            position: "relative",
          }}
        >
          {loading ? (
            <LoadingOutlined style={{ fontSize: "30px" }} />
          ) : (
            <Space direction="vertical" style={{ width: "100%" }}>
              <div className="pos-table-head">
                <div className="pos-table-name">
                  {!screens.md &&
              <LeftOutlined className="backarrow" style={{ marginRight: "10px" }}/>
                  }
                <PageHeader title="Employee Table"
                className="page-header-business" />
              </div>
              {screens.md &&
              <div>
                <Button className="back-login" onClick={()=>backtoLogin()}>Back To Login</Button>
              </div>
}
              </div>
           
              <Row>
                {data.length>0?data.map((table, index) => (
                  <Col
                    className="gutter-row relative menu_cardmain"
                    key={table.id}
                  >
                    <Card
                      style={{
                        width: 140,
                        borderRadius: "10px",
                        padding: "10px",
                        cursor:"pointer"
                      }}
                      onClick={()=>{
                        localStorage.setItem("tableId",table.id)
                        localStorage.setItem("tableNumber",table?.table_number)
                        localStorage.setItem("tableHost",table?.host_employee_id)
                        history.push(`/pos/posmenu`)}}
                      // onClick={()=>history.push(`/pos/menus/server-menu`)}
                    >
                      <Text type="secondary">{"Table no."}</Text>
                      <Text
                        strong
                        style={{ fontSize: "30px", display: "block" }}
                        type="danger"
                      >
                        {table?.table_number}
                      </Text>
                    </Card>
                  </Col>
                )):
                <div className="no-data"><Empty/></div>
                }
              </Row>
            </Space>
          )}
        </Content>
      </Layout>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};

export default withRouter(connect(mapStateToProps)(PosTable));
